namespace Matrix.Administration {
    export interface RunBookUpdateRequest extends Serenity.ServiceRequest {
        StepId?: number;
        Dependencies?: string;
    }
}
